angular.module('SpidApp')

.constant('UserAdapterConfig', {
  name : 'User',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'username',
    	distant : 'username'
    }, {
    	local   : 'password',
    	distant : 'password'
    }, {
    	local   : 'firstname',
    	distant : 'firstname'
    }, {
    	local   : 'lastname',
    	distant : 'lastname'
    }, {
    	local   : 'mail',
    	distant : 'mail'
    }, {
    	local   : 'roles',
    	distant : 'roles'
    }, {
    	local   : 'agency_ids',
    	distant : 'agency_ids'
    }, {
    	local   : 'n',
    	distant : 'n'
    }, {
    	local   : 'state_password',
    	distant : 'state_password'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }, {
    	local   : 'tmp_password',
    	distant : 'tmp_password'
    }, {
    	local   : 'is_actif',
    	distant : 'is_actif'
    }
  ]
})
